import { ApiError, createApiClient } from './client';
import { saveAuthSession } from '../utils/authSession';
import { RUNTIME_API_BASE_URL } from '../config/runtimeApi';

const AUTH_BASE_URL = RUNTIME_API_BASE_URL;

type SendCodeResponseDto = {
  message?: string;
};

type LoginResponseDto = {
  access_token?: string;
  token?: string;
  token_type?: string;
  data?: {
    access_token?: string;
    token?: string;
    token_type?: string;
  };
};

const authClient = createApiClient({
  baseUrl: AUTH_BASE_URL,
});

const getAccessTokenFromResponse = (response: LoginResponseDto): string | null =>
  response.access_token ?? response.token ?? response.data?.access_token ?? response.data?.token ?? null;

const getTokenTypeFromResponse = (response: LoginResponseDto): string | null =>
  response.token_type ?? response.data?.token_type ?? null;

export const sendLoginCode = async (phone: string): Promise<SendCodeResponseDto> => {
  const response = await authClient.request<SendCodeResponseDto>(
    `/api/v1/auth/send-code?phone=${encodeURIComponent(phone)}`,
    { method: 'POST' }
  );
  return response.data;
};

export const loginWithCode = async ({
  phone,
  code,
}: {
  phone: string;
  code: string;
}) => {
  const response = await authClient.post<LoginResponseDto, { phone: string; code: string }>(
    '/api/v1/auth/login',
    { phone, code }
  );
  const accessToken = getAccessTokenFromResponse(response.data);
  if (!accessToken) {
    throw new ApiError('登录成功但未返回访问令牌', 'parse', response.status);
  }
  return saveAuthSession({
    accessToken,
    tokenType: getTokenTypeFromResponse(response.data),
  });
};
